// Arabisch (ar), groeiSchoolApp: zelfde vorm als groeiSchoolApp.nl.ts (golf 3-integratie). Toon:
// geen oordeel over een kind. Nederlandse schoolnamen (AVI, Cito, vmbo, havo, vwo) blijven staan:
// zo staan ze op het rapport; "groep" is المجموعة (zoals in de Arabische folders van gemeenten).
// De toestemmingstekst valt onder GROWTH_CONSENT_TEXT_HASHES (alle talen).
export const appGrowthAr = {
    title: 'النمو',
    intro: 'طول أطفالكم ووزنهم، بهدوء على منحنى نمو. الوالدان فقط يريان هذا. لا يظهر على الجهاز اللوحي إلا إذا أكّد أحد الوالدين ذلك بنفسه صراحةً لجهاز لوحي معيّن، ويمكن إزالته في أي وقت.',
    tab: 'النمو',
    empty: 'لا توجد قياسات بعد. قيسوا بهدوء، مثلًا بعد زيارة مركز رعاية الطفل (consultatiebureau أو JGZ).',
    measurements: '{count} قياسات',
    measurementsOne: 'قياس واحد',
    lastOn: 'آخر قياس في {date}',
    open: 'نمو {name}',
    noConsentYet: 'لم يُفعَّل بعد',
    noMeasurements: 'لا توجد قياسات بعد',
    consent: {
        version: '2026-10-08.1',
        title: 'متابعة نمو {name}؟',
        parental: {
            text: 'الطول والوزن بيانات صحية. نحتفظ بها فقط لنعرض نمو {name} في رسم بياني.\nإذا اخترت مجموعة مرجعية لمنحنى النمو (الأطفال من أصل تركي أو مغربي أو هندوستاني (سورينامي) في هولندا)، نحتفظ بهذا الاختيار أيضًا. وهذا الاختيار يدل على الأصل.\nإذا وُلد {name} قبل موعده، يمكنك إدخال مدة الحمل عند الولادة. وهذه أيضًا بيانات صحية.\nالوالدان في هذه العائلة فقط يريان ذلك. ولا يظهر للأطفال ولا للأقارب المرتبطين. لا يظهر على الجهاز اللوحي إلا إذا أكّد أحد الوالدين ذلك بنفسه صراحةً لجهاز لوحي معيّن، ويمكن إزالته في أي وقت.\nيمكنك تنزيل كل شيء. سحب الموافقة يمحو كل قياسات {name} واختياراته فورًا؛ وتختفي من النسخ الاحتياطية خلال 90 يومًا.\nالخطوط أداة مساعدة، وليست حكمًا ولا تشخيصًا. إن كنت مترددًا، فاسأل مركز رعاية الطفل (consultatiebureau أو JGZ).\nشركة AMUMIN B.V. مسؤولة عن هذه البيانات. حقوقك مذكورة في بيان الخصوصية.',
            check: 'أنا والد/والدة {name} (عمر {name} أقل من 16 سنة) وأوافق على متابعة طول {name} ووزنه واختيارات منحنى النمو.',
        },
        self: {
            text: 'الطول والوزن بيانات صحية. نحتفظ بها فقط لنعرض نموك في رسم بياني.\nإذا اختيرت مجموعة مرجعية لمنحنى نموك (مثلًا من أصل تركي أو مغربي أو هندوستاني (سورينامي) في هولندا)، نحتفظ بهذا الاختيار أيضًا. وهذا الاختيار يدل على الأصل. والأمر نفسه ينطبق على مدة الحمل عند ولادتك إذا وُلدت قبل موعدك: فهذه بيانات صحية.\nالوالدان في هذه العائلة فقط يريان ذلك (أي الوالد الآخر أيضًا). ولا يظهر للأطفال ولا للأقارب المرتبطين. لا يظهر على الجهاز اللوحي إلا إذا أكّد أحد الوالدين ذلك بنفسه صراحةً لجهاز لوحي معيّن، ويمكن إزالته في أي وقت.\nيمكنك تنزيل كل شيء. سحب الموافقة يمحو كل قياساتك واختياراتك فورًا؛ وتختفي من النسخ الاحتياطية خلال 90 يومًا.\nشركة AMUMIN B.V. مسؤولة عن هذه البيانات. حقوقك مذكورة في بيان الخصوصية.',
            check: 'أوافق على متابعة طولي ووزني واختيارات منحنى نموي.',
        },
        /**
         * Aanvulling (0051, tekst 2026-09-28.1): gevraagd op het moment dat een ouder een keuze maakt
         * die een oudere toestemming niet noemde (hs_nl, zwangerschapsduur; bij `self` elke groep
         * behalve nl). De aanvulling noemt altijd ALLE keuzes die die tekst toevoegt (groep en
         * zwangerschapsduur), ook als de ouder er nu maar één kiest: dan dekt ze ze ook echt (review
         * gpl-reg r1). Hoort bij dezelfde hash als parental en self.
         */
        extension: {
            title: 'موافقة على هذه الاختيارات',
            intro: 'لقد أعطيت الموافقة على متابعة نمو {name}. النص في ذلك الوقت لم يذكر بعد كل ما يمكنك اختياره الآن. لذلك نطلب موافقتك بشكل منفصل على هذين الاختيارين، حتى لو اخترت واحدًا منهما فقط الآن:',
            group: 'مجموعة مرجعية للخطوط، مثل الأصل التركي أو المغربي أو الهندوستاني (السورينامي) في هولندا. هذا الاختيار يدل على الأصل: وهو من فئة البيانات الشخصية الخاصة.',
            gestation: 'مدة الحمل عند الولادة، إذا وُلد {name} قبل موعده (من 22 إلى 36 أسبوعًا). وهذه بيانات صحية.',
            rest: 'نستخدم ذلك فقط لخطوط الرسم البياني. الوالدان في هذه العائلة فقط يريان ذلك. لا يظهر على الجهاز اللوحي إلا إذا أكّد أحد الوالدين ذلك بنفسه صراحةً لجهاز لوحي معيّن، ويمكن إزالته في أي وقت. سحب الموافقة يمحوه فورًا مع القياسات. الخطوط ليست حكمًا ولا تشخيصًا.\nبهذه الموافقة يسري على {name} أحدث نص لموافقة متابعة النمو.',
            check: 'أوافق على حفظ هذه الاختيارات لـ {name}.',
            selfText: 'يمكن لوالديك اختيار مجموعة مرجعية لمنحنى نموك (مثلًا من أصل تركي أو مغربي أو هندوستاني (سورينامي) في هولندا). وهذا يدل على الأصل. وإذا وُلدت قبل موعدك، يمكنهما أيضًا إدخال مدة الحمل عند ولادتك: وهذه بيانات صحية. ويلزم لكليهما موافقتك.',
            selfCheck: 'أوافق على حفظ هذه الاختيارات لمنحنى نموي.',
            give: 'إعطاء الموافقة والحفظ',
            giveSelf: 'إعطاء الموافقة',
            needsOwn: '{name} يقرر ذلك بنفسه: يمكن لـ {name} السماح به في قسم النمو في تطبيقه الخاص.',
            selfTitle: 'موافقتك، بالنص الجديد',
            extended: 'استُكملت في {date} بأحدث نص.',
        },
        give: 'إعطاء الموافقة',
        privacyLink: 'اقرأ بيان الخصوصية',
        notNow: 'ليس الآن',
        needsOwn: 'بالنسبة إلى {name}، لا يستطيع إعطاء الموافقة إلا {name} نفسه، بحساب دخول خاص به.',
        needsOwnTeen: 'ابتداءً من سن 16 يقرر {name} بنفسه. بحسابه الخاص يستطيع {name} أن يعطي الموافقة بنفسه في قسم النمو، وبعدها تستطيعون إدخال القياسات.',
        lapsed: 'بلغ {name} الآن 16 سنة ويقرر بنفسه. ما زال بإمكانك عرض القياسات أو تنزيلها أو محوها، لكن لا يمكنك إضافة قياسات جديدة.',
        given: 'أُعطيت الموافقة في {date}',
        givenSelf: 'أعطيت موافقتك بنفسك في {date}',
        givenByThem: 'أعطى {name} موافقته بنفسه في {date}',
        withdraw: 'سحب الموافقة ومحو كل شيء',
        withdrawTitle: 'سحب الموافقة؟',
        withdrawBody: 'ستُمحى كل قياسات {name} فورًا، وكذلك اختيار منحنى النمو. لا يمكن التراجع عن ذلك.',
        withdrawConfirm: 'سحب ومحو',
        withdrawn: 'سُحبت الموافقة. مُحيت قياسات {name}.',
    },
    add: 'إضافة قياس',
    edit: 'تعديل القياس',
    date: 'التاريخ',
    length: 'الطول (سم)',
    weight: 'الوزن (كغ)',
    lengthShort: 'الطول',
    weightShort: 'الوزن',
    bmi: 'مؤشر كتلة الجسم',
    wflShort: 'الوزن/الطول',
    note: 'ملاحظة (اختيارية)',
    notePlaceholder: 'مثلًا: قيس في JGZ',
    oneOfBoth: 'أدخل الطول أو الوزن أو كليهما.',
    saved: 'حُفظ القياس',
    deleted: 'حُذف القياس',
    deleteConfirm: 'حذف هذا القياس؟',
    errors: {
        empty: 'أدخل الطول أو الوزن أو كليهما.',
        length_range: 'هذا الطول غير صحيح. أدخله بالسنتيمتر، مثلًا 123,5.',
        weight_range: 'هذا الوزن غير صحيح. أدخله بالكيلوغرام، مثلًا 24,5.',
        future: 'هذا التاريخ في المستقبل.',
        before_birth: 'هذا التاريخ قبل تاريخ الميلاد.',
        note_long: 'الملاحظة طويلة جدًا (200 حرف على الأكثر).',
        format: 'استخدم رقمًا واحدًا على الأكثر بعد الفاصلة.',
    },
    chart: {
        length: 'الطول حسب العمر',
        weight: 'الوزن حسب العمر',
        bmi: 'مؤشر كتلة الجسم حسب العمر',
        wfl: 'الوزن حسب الطول',
        bmiFrom2: 'نعرض مؤشر كتلة الجسم ابتداءً من سن سنتين.',
        age: 'العمر (بالسنوات)',
        date: 'التاريخ',
        median: 'الوسط (المتوسط)',
        sd1: '−1 و+1 انحراف معياري',
        sd2: '−2 و+2 انحراف معياري',
        you: '{name}',
        lastPoint: 'آخر قياس: {value} في {date}',
        info: 'الخطوط أداة مساعدة، وليست حكمًا ولا تشخيصًا. إن كنت مترددًا، فاسأل مركز رعاية الطفل (consultatiebureau أو JGZ).',
        gaps: {
            no_sex: 'اختر ولدًا أو بنتًا في الأسفل لترى خطوط النمو.',
            no_group: 'اختر مجموعة مرجعية في الأسفل لترى خطوط النمو. بدون اختيار ترى القياسات فقط.',
            no_birth_date: 'أدخل تاريخ الميلاد لترى النمو حسب العمر.',
        },
        source: 'مصدر الخطوط: {source}',
        sources: {
            schonbeck_2011: 'أطفال هولنديون، 2009 ({cite})',
            tno_2010: 'أطفال هولنديون، 2009 ({cite})',
            tno_2010_origin: 'أطفال {group} في هولندا، 2009 ({cite})',
            fredriks_2000: 'أطفال هولنديون، 1997 ({cite})',
            fredriks_2003: 'أطفال {group} في هولندا، 1997 ({cite})',
            fredriks_2004: 'أطفال {group} في هولندا، 1997 ({cite})',
            de_wilde_2014: 'أطفال {group} في هولندا، 2010 ({cite})',
            de_wilde_2013: 'أطفال {group} في هولندا، 1976 ({cite})',
            bocca_2012: 'أطفال وُلدوا بعد {weeks} أسبوعًا من الحمل ({cite})',
            bocca_2012_wfh: 'أطفال وُلدوا مبكرًا ({cite})',
        },
        citations: {
            schonbeck_2011: 'Schönbeck et al., PLoS ONE 2011, CC BY',
            tno_2010: 'TNO, Groeidiagrammen 2010',
            tno_2010_origin: 'TNO, Groeidiagrammen 2010',
            fredriks_2000: 'TNO, Fredriks et al. 2000',
            fredriks_2003: 'TNO, Fredriks et al. 2003',
            fredriks_2004: 'TNO, Fredriks et al. 2004',
            de_wilde_2014: 'TNO, de Wilde et al. 2014',
            de_wilde_2013: 'TNO, de Wilde et al. 2013',
            bocca_2012: 'TNO, Bocca-Tjeertes et al. 2012',
            bocca_2012_wfh: 'TNO, Bocca-Tjeertes et al. 2012',
        },
        /** Golf 19: welke lijnen waar gelden (een tabel per stuk, zie referenceSegments). */
        rangeUntil: 'حتى سن {age}:',
        rangeBetween: 'من سن {from} إلى {to}:',
        rangeFrom: 'من سن {age}:',
        sourceJoin: '؛ ',
        switchNote: 'عند سن {age} تنتقل الخطوط إلى جدول آخر (انظر المصدر في الأسفل). قد تقفز قليلًا هناك.',
        pretermNote: 'حتى سن {age} ترى خطوط الأطفال الذين وُلدوا بعد {weeks} أسبوعًا من الحمل، حسب العمر منذ الولادة. بعد ذلك الخطوط المعتادة.',
        pretermWflNote: 'حتى سن {age} ترى هنا خطوط الأطفال الذين وُلدوا مبكرًا. بعد ذلك الخطوط المعتادة.',
        table: 'جدول بكل القياسات',
        showTable: 'عرض كجدول',
        showChart: 'عرض كرسم بياني',
    },
    settings: {
        title: 'منحنى النمو',
        sex: 'الجنس (لخطوط النمو)',
        sexUnset: 'لم يُختر',
        female: 'بنت',
        male: 'ولد',
        group: 'المجموعة المرجعية',
        groupHint: 'فقط للخطوط في الرسم البياني. اختر الأنسب؛ يمكنك دائمًا تغييره أو تركه فارغًا.',
        groups: {
            none: 'لا شيء (القياسات فقط)',
            nl: 'أطفال هولنديون',
            tr_nl: 'أطفال من أصل تركي في هولندا',
            ma_nl: 'أطفال من أصل مغربي في هولندا',
            hs_nl: 'أطفال من أصل هندوستاني (سورينامي) في هولندا',
        },
        groupNames: {
            nl: 'هولنديون',
            tr_nl: 'من أصل تركي',
            ma_nl: 'من أصل مغربي',
            hs_nl: 'من أصل هندوستاني (سورينامي)',
        },
        /** Golf 19: neutrale uitleg bij de groepen en de zwangerschapsduur (alleen te vroeg). */
        groupInfo: 'تأتي خطوط كل مجموعة من أبحاث هولندية على أطفال من ذلك الأصل. الهندوستاني (السورينامي) يعني أطفالًا لهم أجداد من جنوب آسيا، غالبًا عن طريق سورينام. ليس لكل مجموعة خطوط خاصة لكل قياس؛ تحت الرسم البياني ترى أي خطوط معروضة.',
        gestation: 'مدة الحمل عند الولادة',
        gestationNone: 'وُلد في موعده (أو لم يُدخل)',
        gestationWeeks: '{weeks} أسبوعًا',
        gestationHint: 'املأ هذا فقط إذا وُلد {name} مبكرًا (قبل {term} أسبوعًا). عندها ترى حتى سن {age} خطوط الأطفال الذين وُلدوا مبكرًا؛ ومن {min} إلى {max} أسبوعًا هي خطوط {table} أسبوعًا. هذه معلومة صحية: تخضع للموافقة نفسها مثل القياسات، ولا يراها إلا الوالدان، وسحب الموافقة يمسحها أيضًا.',
        saved: 'تم الحفظ',
    },
    birthDate: 'تاريخ ميلاد {name}',
    birthDateHint: 'ضروري للنمو حسب العمر. يظهر أيضًا في أعياد الميلاد.',
    download: 'تنزيل',
    downloadCsv: 'كجدول (CSV)',
    downloadJson: 'كل شيء (JSON)',
    clear: 'محو كل القياسات',
    clearTitle: 'محو كل قياسات {name}؟',
    clearBody: 'تبقى الموافقة قائمة، حتى تتمكن من البدء من جديد. لا يمكن التراجع عن ذلك.',
    cleared: 'مُحيت كل قياسات {name}.',
    privacyNote: 'الوالدان فقط يريان هذا. لا يظهر على الجهاز اللوحي إلا إذا أكّد أحد الوالدين ذلك بنفسه صراحةً لجهاز لوحي معيّن، ويمكن إزالته في أي وقت.',
    selfIntro: 'طولك ووزنك في منحنى نمو هادئ. والداك يُدخلان القياسات، ولا يرى هذا إلا أنت ووالداك.',
    selfUnder16: 'والداك يتابعان طولك ووزنك. ابتداءً من سن 16 تقرر ذلك بنفسك.',
    selfNote: 'لا يرى هذا إلا أنت ووالداك. لا يظهر على الجهاز اللوحي إلا إذا أكّد أحد الوالدين ذلك بنفسه صراحةً لجهاز لوحي معيّن، ويمكن إزالته في أي وقت.',
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: ['التاريخ', 'الطول_سم', 'الوزن_كغ', 'مؤشر_كتلة_الجسم', 'ملاحظة'],
    moduleOff: 'النمو جزء من وحدة الصحة. وهي مطفأة.',
};
export const appSchoolAr = {
    title: 'المدرسة',
    intro: 'علامات التقارير والاختبارات لكل طفل، بهدوء على خط زمني. الوالدان فقط يريان هذا؛ ولا يظهر أبدًا على الجهاز اللوحي.',
    childIntro: 'تقاريرك واختباراتك. والداك يُدخلان هذا.',
    childOff: 'لم يفعّل والداك هذا لك بعد.',
    tab: 'المدرسة',
    open: 'مدرسة {name}',
    noChildren: 'لا يوجد أطفال في عائلتكم بعد.',
    empty: 'لم يُدخل شيء بعد. ابدأ بآخر تقرير أو باختبار.',
    nothingYet: 'لم يُدخل شيء بعد',
    count: '{count} نتائج',
    countOne: 'نتيجة واحدة',
    add: 'إضافة نتيجة',
    edit: 'تعديل النتيجة',
    saved: 'تم الحفظ',
    deleted: 'تم الحذف',
    deleteConfirm: 'حذف هذه النتيجة؟',
    timeline: 'الخط الزمني',
    trends: 'حسب المادة',
    noTrend: 'يظهر خط عندما تكون هناك نتيجتان أو أكثر.',
    childView: 'هل يُسمح لـ {name} برؤية هذا بنفسه؟',
    childViewHint: 'فقط بحساب دخول خاص في تطبيق الويب، نتائجه فقط، وللقراءة فقط. ولا يظهر أبدًا على الجهاز اللوحي.',
    childViewOn: 'يستطيع {name} الآن رؤية هذا بنفسه.',
    childViewOff: 'لا يرى {name} هذا.',
    download: 'تنزيل',
    downloadCsv: 'كجدول (CSV)',
    downloadJson: 'كل شيء (JSON)',
    clear: 'محو كل ما يخص {name}',
    clearTitle: 'محو كل نتائج {name}؟',
    clearBody: 'لا يمكن التراجع عن ذلك.',
    cleared: 'مُحيت كل نتائج {name}.',
    field: {
        kind: 'النوع',
        schoolYear: 'السنة الدراسية',
        period: 'الموعد',
        date: 'التاريخ (اختياري)',
        group: 'المجموعة (groep)',
        groupNone: 'غير معروف',
        subject: 'المادة',
        domain: 'الجزء',
        scale: 'المقياس',
        grade: 'العلامة',
        gradeHint: 'من 1 إلى 10، مثلًا 7,5',
        word: 'التقييم',
        level: 'المستوى',
        score: 'درجة المهارة (اختيارية)',
        dmtScore: 'الدرجة (عدد الكلمات الصحيحة)',
        provider: 'اختبار من (اختياري)',
        note: 'ملاحظة (اختيارية)',
    },
    errors: {
        school_year: 'اختر سنة دراسية.',
        period: 'اختر موعدًا يناسب هذا النوع.',
        group: 'اختر مجموعة من 1 إلى 8.',
        subject: 'اختر مادة.',
        domain: 'اختر جزءًا.',
        scale: 'اختر مقياسًا.',
        value: 'هذه القيمة لا تناسب المقياس.',
        provider: 'اختر اختبارًا من القائمة.',
        note: 'الملاحظة طويلة جدًا (200 حرف على الأكثر).',
        future: 'هذا التاريخ في المستقبل.',
        subject_dup: 'هذه المادة موجودة بالفعل.',
    },
    /** Titels van een lijn "Per vak" (review g3-ux r1): rapport en toets nooit dezelfde titel. */
    titles: {
        grade: '{subject} · التقرير',
        lvs: 'اختبار · {domain}',
    },
    kinds: {
        grade: 'علامة التقرير',
        lvs: 'اختبار (نظام متابعة التلميذ، LVS)',
        avi: 'مستوى القراءة AVI',
        dmt: 'DMT (اختبار الدقائق الثلاث)',
        level: 'مستوى الأداء (functioneringsniveau)',
        doorstroom: 'اختبار الانتقال في المجموعة 8 (doorstroomtoets)',
        advies: 'التوصية المدرسية (schooladvies)',
    },
    periods: {
        b: 'البداية',
        r1: 'التقرير 1',
        m: 'المنتصف',
        r2: 'التقرير 2',
        r3: 'التقرير 3',
        e: 'النهاية',
        r4: 'التقرير 4',
        voorlopig: 'مؤقت',
        definitief: 'نهائي',
    },
    periodsShort: {
        b: 'بداية',
        r1: 'ت1',
        m: 'منتصف',
        r2: 'ت2',
        r3: 'ت3',
        e: 'نهاية',
        r4: 'ت4',
        voorlopig: 'مؤقت',
        definitief: 'نهائي',
    },
    scales: {
        number: 'علامة 1-10',
        word: 'كلمات (من O إلى ZG)',
        roman: 'من I إلى V',
        letter: 'من A إلى E',
        ref: '1F / 2F / 1S',
    },
    domains: {
        rekenen: 'الحساب',
        begrijpend_lezen: 'القراءة والفهم',
        spelling: 'الإملاء',
        technisch_lezen: 'القراءة التقنية',
        lezen: 'القراءة',
        taalverzorging: 'سلامة اللغة',
    },
    providers: {
        cito: 'Cito (Leerling in beeld)',
        boom: 'Boom LVS',
        iep: 'IEP',
        dia: 'Diatoetsen',
        amn: 'AMN',
        route8: 'ROUTE 8',
        doe: 'DOE-toets',
        other: 'غير ذلك',
    },
    words: {
        O: 'غير كافٍ',
        M: 'متوسط',
        V: 'كافٍ',
        RV: 'أكثر من كافٍ',
        G: 'جيد',
        ZG: 'جيد جدًا',
    },
    advice: {
        pro: 'Praktijkonderwijs (التعليم العملي)',
        vmbo_b: 'vmbo basis',
        vmbo_b_k: 'vmbo basis / kader',
        vmbo_k: 'vmbo kader',
        vmbo_k_gt: 'vmbo kader / gt',
        vmbo_gt: 'vmbo gemengd/theoretisch (gt)',
        vmbo_gt_havo: 'vmbo gt / havo',
        havo: 'havo',
        havo_vwo: 'havo / vwo',
        vwo: 'vwo',
    },
    explain: {
        grade: 'علامة تقرير من 1 إلى 10. العلامة 5,5 أو أعلى كافية.',
        word: '{code} = {word}.',
        aviStart: 'AVI-Start = بداية تعلّم القراءة، في المجموعة 3.',
        aviPlus: 'AVI-Plus = أعلى مستوى في AVI، بعد نهاية المجموعة 7.',
        avi: 'AVI {code} = مستوى القراءة في {moment} المجموعة {group}.',
        level: '{code} = المستوى في {moment} المجموعة {group}.',
        roman: {
            I: 'I = ضمن أعلى 20% من الأطفال في هولندا.',
            II: 'II = فوق المتوسط بقليل (الـ 20% التالية).',
            III: 'III = حول المتوسط (الـ 20% الوسطى).',
            IV: 'IV = تحت المتوسط بقليل (الـ 20% التالية).',
            V: 'V = ضمن أدنى 20%. عندها تنظر المدرسة في ما يساعد إضافيًا.',
        },
        letter: {
            A: 'A = ضمن أعلى 25% من الأطفال في هولندا.',
            B: 'B = فوق المتوسط بقليل (الـ 25% التالية).',
            C: 'C = تحت المتوسط بقليل (الـ 25% التالية).',
            D: 'D = تحت المتوسط بوضوح (الـ 15% التالية).',
            E: 'E = ضمن أدنى 10%. عندها تنظر المدرسة في ما يساعد إضافيًا.',
        },
        ref: {
            '<1F': 'لم يُبلغ 1F بعد. وهو المستوى الأساسي لنهاية المجموعة 8.',
            '1F': '1F = المستوى الأساسي الذي يبلغه تقريبًا كل الأطفال في نهاية المجموعة 8.',
            '2F': '2F = المستوى المنشود في القراءة واللغة في نهاية المجموعة 8.',
            '1S': '1S = المستوى المنشود في الحساب في نهاية المجموعة 8.',
        },
        dmt: 'يقيس DMT عدد الكلمات المنفردة التي يقرؤها الطفل بشكل صحيح في ثلاث دقائق.',
        doorstroom: 'اختبار الانتقال (منذ 2024) يقيس القراءة وسلامة اللغة والحساب بمستويات 1F و2F و1S.',
        advies: 'التوصية المدرسية تقول أي نوع من التعليم الثانوي يناسب.',
        moments: { B: 'بداية', M: 'منتصف', E: 'نهاية' },
    },
    subjects: {
        title: 'المواد',
        hint: 'المواد في تقرير مدرستكم. يمكنك إعادة تسميتها أو إزالتها؛ وتبقى العلامات القديمة.',
        add: 'إضافة مادة',
        name: 'اسم المادة',
        suggested: 'إضافة المواد المعتادة',
        suggestions: [
            'الحساب',
            'اللغة',
            'الإملاء',
            'القراءة',
            'القراءة والفهم',
            'الكتابة',
            'الجغرافيا',
            'التاريخ',
            'العلوم',
            'الإنجليزية',
        ],
        remove: 'إزالة',
        rename: 'إعادة تسمية',
        removed: 'أُزيلت المادة. تبقى العلامات القديمة.',
        none: 'لا توجد مواد بعد. أضفها أو اختر المواد المعتادة.',
        archived: '{name} (أُزيلت)',
    },
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: [
        'السنة_الدراسية',
        'الفترة',
        'التاريخ',
        'المجموعة',
        'النوع',
        'المادة_أو_المجال',
        'القيمة',
        'الاختبار',
        'ملاحظة',
    ],
    moduleOff: 'المدرسة مطفأة.',
};
//# sourceMappingURL=groeiSchoolApp.ar.js.map